import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs';
import { SiteDto } from '../../../dtos/siteDto';
import { UserDto } from '../../../dtos/userDto';

@Injectable({
    providedIn: 'root'
})
export class UserDataService {

    private _currentUser: BehaviorSubject<UserDto> = new BehaviorSubject<UserDto>(new UserDto());
    public readonly currentUser: Observable<UserDto> = this._currentUser.asObservable();

    constructor() {
    }

    setUser(user: UserDto) {
        this._currentUser.next(user);
    }

    //Synchronous access of the currentUser use it if the flow of the app needs it
    getUser(): UserDto {
        return this._currentUser.getValue();
    }
}
